// Online visit is not tied to a city: the doctors of /s/<city>/…?turn_type=consult come from all over Iran,
// so the landing's links must not say «… شهرکرد». Only the visible title changes — the link (url) is left as it
// is, and so is the national consult page (no city in its titles, nothing to strip).
type TitledItem = { title?: unknown; type?: unknown };

export const stripCitySuffix = (title: string, cityName?: string): string => {
  const city = String(cityName ?? '').trim();
  if (!city || !title.endsWith(` ${city}`)) return title;
  return title.slice(0, -city.length - 1).trimEnd() || title;
};

export const stripCityFromOnlineLandingTitles = <T extends TitledItem>(result: T[], isLanding: boolean, isConsult: boolean, cityName?: string): T[] => {
  if (!isLanding || !isConsult || !cityName || !Array.isArray(result)) return result;
  let changed = false;
  const next = result.map(item => {
    if (item?.type !== 'group_expertise' || typeof item.title !== 'string') return item;
    const title = stripCitySuffix(item.title, cityName);
    if (title === item.title) return item;
    changed = true;
    return { ...item, title };
  });
  return changed ? next : result;
};
